import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';

export const initParkingLocation: ParkingLocation = {
	customerID: '',
	id: '0',
	name: '',
	parkingZoneOptions: [
		{
			id: 0,
			name: '',
		},
	],
	// Rules
	violationCheckType: 'fixedMonthly',
	violationCheckWindowDays: 30,
	taggingPolicyType: 'afterXViolations',
	taggingAfterViolations: 2,
	towPolicyType: 'afterXViolations',
	towAfterViolations: 5,
	// Stage gates (positive naming: true = stage runs)
	showScanPreview: true,
	showActionStage: true,
	showCarPhotoStage: false,
	showConfirmStage: true,
	// Notifications
	enableOverstayNotifications: false,
	// Towing Info
	towingCompanyNumber: '',
	towingCompanyName: '',
	towInstructions: '',
} as ParkingLocation;
